import { Button, tokens } from '@arvoreeducacao/bonsai-ds'
import styled from 'styled-components'

export const SearchResultsListWrapper = styled.div`
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 0px 10px;

  button {
    width: 100%;
  }

  @media (min-width: ${tokens.breakpoints.tablet}px) {
    width: ${tokens.breakpoints.tablet}px;
    padding: 0px 10px;
  }

  @media (min-width: ${tokens.breakpoints.desktop}px) {
    width: 100%;
    padding: 0px;

    button {
      width: 420px;
    }
  }

  [data-testid='list-item-book'] {
    cursor: pointer;
    transition: ${tokens.transitions.motionFast2};
    &:hover {
      background-color: ${tokens.colors.dark1};
      strong {
        color: ${tokens.colors.dark6} !important;
      }
    }
  }

  [data-testid='list-item-book']:first-child {
    border-radius: ${tokens.radius.xlarge} ${tokens.radius.xlarge} 0px 0px;
  }
`

export const ContentList = styled.div`
  padding: ${tokens.spacing.verticalXsmall} 0px;
  width: 100%;

  @media (min-width: ${tokens.breakpoints.desktop}px) {
    padding: 0px 0px ${tokens.spacing.verticalXsmall} 0px;
  }

  [role='list-book'],
  [data-testid='list-book'] {
    width: 100%;
    justify-content: space-between;

    div:nth-child(2) {
      width: 100%;
    }

    span {
      position: relative;
      margin-right: -${tokens.spacing.horizontalMedium};
    }
  }
`

export const ButtomSearch = styled(Button)<{
  colorBackground?: string
  colorBackgroundHover?: string
}>`
  margin-bottom: ${tokens.spacing.horizontalXsmall};
  background-color: ${({ colorBackground }) =>
    colorBackground ? colorBackground : ''};
  padding: ${tokens.spacing.horizontalSmall};

  &:hover {
    background-color: ${({ colorBackgroundHover }) =>
      colorBackgroundHover ? colorBackgroundHover : ''};
  }
`

export const SuggestBookBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${tokens.spacing.verticalMedium};
  width: 100%;
  margin: ${tokens.spacing.verticalMedium} 0 ${tokens.spacing.verticalLarge};
  padding: 0 ${tokens.spacing.horizontalMedium};
`

export const SuggestBookText = styled.p`
  color: ${tokens.colors.dark5};
  text-align: center;
  font-size: ${tokens.fontSize.medium}px;
  font-weight: ${tokens.fontWeights.regular};
  line-height: ${tokens.lineHeight.medium}%;
  margin: 0;
  max-width: 500px;
`

export const SuggestButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: ${tokens.spacing.verticalMedium};
  padding: 0 ${tokens.spacing.horizontalMedium};

  button {
    width: auto;
  }
`
